import {stock_info} from "../../api/bc_stock.api"

const actions = {
    load_stock_info({state, commit},bc) {

        return new Promise((resolve, reject) =>
            stock_info(bc)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    }
}

export default {
    namespaced: true,
    actions
}